/*!
 * devextreme-angular
 * Version: 19.1.3
 * Build date: Tue May 14 2019
 *
 * Copyright (c) 2012 - 2019 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

/* tslint:disable:max-line-length */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input
} from '@angular/core';




import DevExpress from 'devextreme/bundles/dx.all';

import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';


@Component({
    selector: 'dxo-marker',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
})
export class DxoMarkerComponent extends NestedOption {
    @Input()
    get label(): { customizeText?: Function, format?: DevExpress.ui.format | string } {
        return this._getOption('label');
    }
    set label(value: { customizeText?: Function, format?: DevExpress.ui.format | string }) {
        this._setOption('label', value);
    }

    @Input()
    get separatorHeight(): number {
        return this._getOption('separatorHeight');
    }
    set separatorHeight(value: number) {
        this._setOption('separatorHeight', value);
    }

    @Input()
    get textLeftIndent(): number {
        return this._getOption('textLeftIndent');
    }
    set textLeftIndent(value: number) {
        this._setOption('textLeftIndent', value);
    }

    @Input()
    get textTopIndent(): number {
        return this._getOption('textTopIndent');
    }
    set textTopIndent(value: number) {
        this._setOption('textTopIndent', value);
    }

    @Input()
    get topIndent(): number {
        return this._getOption('topIndent');
    }
    set topIndent(value: number) {
        this._setOption('topIndent', value);
    }

    @Input()
    get visible(): boolean {
        return this._getOption('visible');
    }
    set visible(value: boolean) {
        this._setOption('visible', value);
    }


    protected get _optionPath() {
        return 'marker';
    }


    constructor(@SkipSelf() @Host() parentOptionHost: NestedOptionHost,
            @Host() optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

}

@NgModule({
  declarations: [
    DxoMarkerComponent
  ],
  exports: [
    DxoMarkerComponent
  ],
})
export class DxoMarkerModule { }
